import { useAuth, USER_ROLE } from "contexts/auth/auth.context";
import { Navigate } from "react-router";

interface Props {
  children: React.ReactNode;
  allowedRoles?: USER_ROLE[]
}

export const ProtectedRoute = ({ children, allowedRoles }: Props) => {
  const { isAuthenticated, getRole, getHasAdminRights } = useAuth();
  const role = getRole();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles?.includes(role)) {
    return children;
  }

  if (getHasAdminRights() && allowedRoles?.includes(USER_ROLE.ROLE_DOCTOR)) {
    return children;
  }

  return <Navigate to="/login" replace />;
};
